
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42.252 33.991"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#707070","stroke-miterlimit":"10","stroke-width":"2"}},[_c('path',{attrs:{"d":"M26.794 9.061a5.439 5.439 0 11-5.438-5.439h0a5.431 5.431 0 015.439 5.406l-.001.033zM37.607 5.293a4.28 4.28 0 110-.026zM13.432 5.293a3.636 3.636 0 11.006-.032.07.07 0 00-.006.032z","fill":"none"}}),_c('path',{attrs:{"data-name":"Path 527","d":"M36.183 23.68h-5.726c-2.8 0-5.076 4.293-5.076 1.489v-7.413a7.939 7.939 0 017.938-7.938h0a7.939 7.939 0 017.938 7.938v.855a5.061 5.061 0 01-5.074 5.069z","fill":"none"}}),_c('path',{attrs:{"data-name":"Path 528","d":"M11.812 23.68H6.076A5.076 5.076 0 011 18.604v-.855a7.939 7.939 0 017.938-7.937h0a7.939 7.939 0 017.938 7.938v7.42c.006 2.803-2.267-1.49-5.064-1.49z","fill":"none"}}),_c('path',{attrs:{"data-name":"Path 529","d":"M25.946 32.991h-9.181a5.076 5.076 0 01-5.076-5.076v-3.568a9.667 9.667 0 019.666-9.666h0a9.667 9.667 0 019.666 9.666v3.567a5.076 5.076 0 01-5.075 5.077z","fill":"#fff"}})])])
          )
        }
      }
    